
import { Box, Modal } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
const FinalGradeBaseList = () => {
    const navigate = useNavigate()
    const {id, groupId, type} = useParams()
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        color:'black',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        pt: 2,
        px: 4,
        pb: 3,
      };
    const handleClose = () => {
        navigate(`/${type}/${groupId}/groups/${id}`)
      };
  return (
    <Modal
  open={true}
  onClose={handleClose}
  aria-labelledby="parent-modal-title"
  aria-describedby="parent-modal-description"
>
  <Box sx={{ ...style, width: 400 }}>
    <h2 id="parent-modal-title">גליון הציונים בוצע בהצלחה</h2>
    <p id="parent-modal-description">
      גליון הציונים בוצע בהצלחה.
    </p>
    
  </Box>
</Modal>
  )
}

export default FinalGradeBaseList